
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TimeFrameItemProps } from ".";
import { loading, endLoading } from "store/time-frame";

interface ApiTimeFrameRemoveInputProps {
    ids: number[]
}

type ApiTimeFrameRemoveOutputProps = OutputBaseProps<{ item: TimeFrameItemProps; }>;

export const apiTimeFrameRemove = async (data: ApiTimeFrameRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiTimeFrameRemoveOutputProps>("/api/time-frame/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};